export default __webpack_public_path__ + "static/media/avatar-s-7.ba3f6823.jpg";